import React, { FC, useCallback } from "react";
import { IHeaderParams } from "ag-grid-community";

import { useParameter } from "../../../shared";

const AgGridHeaderComponent: FC<IHeaderParams> = ({ displayName, column }) => {
  const [, selectCommodityId] = useParameter<number>("@selected_commodity_id");
  const [, selectUnitId] = useParameter<number>("@selected_unit_id");

  const onClickHandler = useCallback(() => {
    const columnId = column.getColId();
    const columnParts = columnId.split(":");

    if (columnParts.length === 2) {
      const [commodityId, unitId] = columnParts;

      selectCommodityId(Number(commodityId));
      selectUnitId(Number(unitId));
    }
  }, [column]);

  return (
    <div className="ag-header-group-cell-label ag-header-commodity-link" onClick={onClickHandler}>
      <span className="ag-header-cell-text">{displayName}</span>
    </div>
  );
};

export { AgGridHeaderComponent };
